// extracted by mini-css-extract-plugin
export default {"range":"dt_range__01Urt","single":"dt_single__Cs+cR"};